// Cypress support :(
// https://github.com/cypress-io/cypress/issues/95
delete window.fetch;
// eslint-disable-next-line import/first
import 'whatwg-fetch';
// ------------------

export class ErrorAPI extends Error {
  status: number;

  constructor({ status }: { status: number }) {
    super('API Error');
    this.status = status;
  }
}

const call = (api?: string, tokenTemplate = (token: null | string) => `Bearer ${token}`) => async <
  R
>(
  method: string,
  url: string,
  token: null | string,
  body?: Record<string, unknown>,
  options: RequestInit = {},
): Promise<R> => {
  const finalHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(token && { Authorization: tokenTemplate(token) }),
    ...options.headers,
  };

  const response = await fetch(`${api}${url}`, {
    ...options,
    body: JSON.stringify(body),
    headers: finalHeaders,
    method,
    mode: 'cors',
  });

  if (response.ok) {
    try {
      return await response.json();
    } catch (e) {
      return Promise.resolve((undefined as unknown) as R);
      // Error / Different content type ?
    }
  }

  throw new ErrorAPI({
    status: response.status,
  });
};

export const callApi = call(process.env.APM_API_URL);
export const callAuth = call(process.env.APM_AUTH_URL);
export const callBitriseApi = call(process.env.BITRISE_API_URL, (t) => `token ${t}`);
export const callBitriseApp = call(process.env.BITRISE_APP_AUTH_URL);
export const callCloud = call(process.env.CLOUD_FUNCTION_URL);
